<nz-anchor
  [nzAffix]="true"
  [nzOffsetTop]="100"
  [nzTargetOffset]="300"
  (nzChange)="onAnchorChange($event)"
>
  <nz-link
    *ngFor="let item of list; let i = index"
    [nzHref]="'#' + item.name"
    [nzTitle]="item.name"
    [class.default-active]="
      (!activeId || activeId === '#' + list[0].name) && i === 0
    "
  ></nz-link>
</nz-anchor>
